"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var AboutHeaderDetailItems_1 = require("../AboutHeaderDetailItems");
function renderDatabaseType(database) {
    return database.connectionType ?
        AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.ConnectionType(), data_catalog_shared_1.messageForConnectionType(database.connectionType), 'database-details-database-type-test-id')
        : null;
}
function renderCategory(database) {
    return database.isGrouped
        ? AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.DatabaseCategory(), Localize_1.Messages.DatabaseCategoryGroupedDatabase(), 'database-details-database-category-test-id')
        : null;
}
function renderDetails(database) {
    var element = [];
    switch (database.__typename) {
        case 'DatabaseServer':
            if (database.hostName) {
                element.push(AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.Hostname(), database.hostName, 'database-details-hostname-test-id'));
            }
            element.push(renderDatabaseType(database));
            break;
        case 'File':
            if (database.filePath) {
                element.push(AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.FilePath(), database.filePath, 'database-details-filepath-test-id'));
            }
            if (database.connectionType) {
                element.push(AboutHeaderDetailItems_1.renderFileType(database.connectionType));
            }
            break;
        case 'CloudFile':
            if (database.connectionType) {
                element.push(AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.ConnectionType(), data_catalog_shared_1.messageForConnectionType(database.connectionType), 'database-details-connection-type-test-id'));
            }
            break;
        case 'WebDataConnector':
            if (database.connectorUrl) {
                element.push(AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.WebDataConnectorUrl(), database.connectorUrl, 'database-details-web-data-connector-url-test-id'));
            }
            element.push(AboutHeaderDetailItems_1.renderAboutHeaderTextDetailItem(Localize_1.Messages.ConnectionType(), Localize_1.Messages.WebDataConnector(), 'database-details-wdc-connection-type-test-id'));
            break;
        default:
            element.push(renderDatabaseType(database));
    }
    if (database.isEmbedded) {
        element.push(AboutHeaderDetailItems_1.renderEmbeddedAssetDescription('database-asset-details-category-test-id'));
    }
    return element;
}
function DatabaseDetails(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement("div", { "data-tb-test-id": 'database-details-wrapper-test-id', className: data_catalog_shared_1.aboutHeaderDetailsWrapper },
            React.createElement("div", { className: data_catalog_shared_1.aboutHeader }, Localize_1.Messages.About()),
            React.createElement("div", null,
                React.createElement(data_catalog_shared_1.HorizontalFlexContainer, { fillFlexParent: true },
                    renderDetails(props.database),
                    renderCategory(props.database)),
                'tags' in props.database ?
                    AboutHeaderDetailItems_1.renderAboutHeaderTagsDetailList(props.database.tags, 'database-details-tags-test-id', urls, props.database.__typename) : null,
                AboutHeaderDetailItems_1.renderAboutHeaderDescriptionDetailItem(props.database.description ? props.database.description : '', 'database-details-description-test-id')));
    }));
}
exports.DatabaseDetails = DatabaseDetails;
//# sourceMappingURL=DatabaseDetails.js.map